module.exports = __webpack_public_path__ + "static/57.f22595e0.jpg";